const mine = [{
    path: '/favorites',
    name: 'favorites',
    component: () => import( /* webpackChunkName: "favorites" */ '@/pages/mine/favorites.vue'),
    meta: {
      login: true,
      titleBar: {
        title: '我的收藏',
        hasMenu: true
      }
    }
  },
  {
    path: '/footmark',
    name: 'footmark',
    component: () => import( /* webpackChunkName: "footmark" */ '@/pages/mine/footmark.vue'),
    meta: {
      login: true,
      titleBar: {
        title: '我的足迹',
        hasMenu: true
      }
    }
  },
  {
    path: '/frequent-contact',
    component: () => import( /* webpackChunkName: "frequent-contact" */ '@/pages/frequent-contact/index'),
    name: 'frequent-contact',
    meta: {
      title: '袋鼠健康',
      login: true,
      titleBar: {
        title: '常用联系人'
      }
    }
  },
  {
    path: '/add-contact',
    component: () => import( /* webpackChunkName: "add-contact" */ '@/pages/frequent-contact/add-contact'),
    name: 'add-contact',
    meta: {
      title: '袋鼠健康',
      login: true,
      titleBar: {
        title: '新增常用联系人'
      }
    }
  },
  {
    path: '/message-center',
    component: () => import( /* webpackChunkName: "message-center" */ '@/pages/mine/message-center'),
    name: 'message-center',
    meta: {
      title: '袋鼠健康',
      login: true,
      titleBar: {
        title: '消息中心',
        hasMenu: true
      },
      keepAlive: []
    }
  },
  {
    path: '/message-detail',
    component: () => import( /* webpackChunkName: "message-detail" */ '@/pages/mine/message-detail'),
    name: 'message-detail',
    meta: {
      title: '袋鼠健康',
      login: true,
      titleBar: {
        title: '消息详情',
        hasMenu: true
      }
    }
  },
  {
    path: '/setting',
    component: () => import( /* webpackChunkName: "setting" */ '@/pages/mine/setting'),
    name: 'setting',
    meta: {
      title: '袋鼠健康',
      login: true,
      titleBar: {
        title: '设置',
        hasMenu: true
      }
    }
  },
  {
    path: '/policy-protocol',
    component: () => import( /* webpackChunkName: "policy-protocol" */ '@/pages/mine/policy-protocol'),
    name: 'policy-protocol',
    meta: {
      title: '袋鼠健康',
      login: true,
      titleBar: {
        title: '协议及政策',
        hasMenu: true
      }
    }
  },
  {
    path: '/exchange-center',
    component: () => import(/* webpackChunkName: "policy-protocol" */ '@/pages/exchange-center/exchange'),
    name: 'exchange-center',
    meta: {
      title: '兑换中心',
      login: true,
      titleBar: {
        title: '兑换中心',
        hasMenu: true
      }
    }
  },
  {
    path: '/personal-info',
    component: () => import( /* webpackChunkName: "personal-info" */ '@/pages/mine/personal-info'),
    name: 'personal-info',
    meta: {
      title: '袋鼠健康',
      login: true,
      titleBar: {
        title: '个人资料',
        hasMenu: true
      }
    }
  },
  {
    path: '/exchange-result',
    component: () => import(/* webpackChunkName: "policy-protocol" */ '@/pages/exchange-center/result'),
    name: 'exchange-result',
    meta: {
      title: '兑换中心',
      login: true,
      titleBar: {
        title: '兑换中心',
        hasMenu: true
      },
    }
  },
  {
    path: '/set-name',
    component: () => import( /* webpackChunkName: "set-name" */ '@/pages/mine/set-name'),
    name: 'set-name',
    meta: {
      title: '袋鼠健康',
      login: true,
      // titleBar: {
      //   title: '设置昵称',
      //   hasMenu: false
      // }
    }
  },
  {
    path: '/set-phone',
    component: () => import( /* webpackChunkName: "set-phone" */ '@/pages/mine/set-phone'),
    name: 'set-phone',
    meta: {
      title: '袋鼠健康',
      login: true,
      titleBar: {
        title: '设置手机号',
        hasMenu: false
      }
    }
  },
  {
    path: '/exchange-rules',
    component: () => import(/* webpackChunkName: "policy-protocol" */ '@/pages/exchange-center/exchange-rules'),
    name: 'exchange-rules',
    meta: {
      title: '兑换规则',
      login: true,
      titleBar: {
        title: '兑换规则',
        hasMenu: true
      }
    }
  },
  {
    path: '/set-phone-one',
    component: () => import( /* webpackChunkName: "set-phone-one" */ '@/pages/mine/set-phone-one'),
    name: 'set-phone-one',
    meta: {
      title: '袋鼠健康',
      login: true,
      titleBar: {
        title: '设置手机号',
        hasMenu: false
      }
    }
  },
  {
    path: '/set-phone-two',
    component: () => import( /* webpackChunkName: "set-phone-two" */ '@/pages/mine/set-phone-two'),
    name: 'set-phone-two',
    meta: {
      title: '袋鼠健康',
      login: true,
      titleBar: {
        title: '设置手机号',
        hasMenu: false
      }
    }
  },
]

export default mine
